<template>
  <v-bottom-navigation
      light mandatory grow absolute
      class="bottom-menu"
  >
    <v-btn plain icon depressed :ripple="false"
           v-for="(menu, n) in menus"
           :key="n"
           exact
           to="./"
           active-class="none"
           :class="[
             { 'show-tooltip': isShowTooltip },
             { 'current' : activeMenu === menu.code }
           ]"
           @click.prevent
    >
      <span class="label pos-relative">
        <v-tooltip attach
                   top
                   transition="none"
                   max-width="100vw"
                   class="tooltip-coach"
                   :value="isShowTooltip && tooltipActive">
          <template v-slot:activator="{ attrs }">
              <span v-bind="attrs"
              >{{ menu.codeName }}</span>
          </template>
          <span class="tooltip-text" :id="`tooltip${menu.code}`">{{ menu.tooltip }}</span>
        </v-tooltip>
      </span>
      <span class="bottom-icon" v-if="isSamsungFire">
        <component :is="menu.icon" :active="activeMenu === menu.code" />
      </span>
      <i v-else :class="`cu-icon-bottom-menu-${menu.icon.toLowerCase()}`"></i>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import {mixinAuth} from '@/mixins'
import Home from '@/components/icons/MenuHome'
import Library from '@/components/icons/MenuLibrary'
import Chat from '@/components/icons/MenuChat'
import Square from '@/components/icons/MenuSquare'
import Travel from '@/components/icons/MenuTravel'

export default {
  name: 'CoachMarkBottomMenu',
  components: {
    Home,
    Library,
    Chat,
    Square,
    Travel
  },
  mixins: [mixinAuth],
  props: {
    isShowTooltip: {
      type: Boolean,
      default: false
    },
    activeMenu: {
      type: String,
      default: null
    }
  },
  data: () => ({
    tooltipActive: false,
    menus: [
      {code: 'Home', codeName: '메인', url: '#', icon: 'Home', tooltip: '오늘의 미션\n맞춤형으로 제공되는 추천 미션 클리어!'},
      {code: 'Library', codeName: '도서관', url: '#', icon: 'Library', tooltip: '다양한\n심리 콘텐츠 제공'},
      {code: 'Mission', codeName: '미션', url: '#', icon: 'Mission', tooltip: '맞춤형으로 제공되는\n오늘의 미션'},
      {code: 'Square', codeName: '광장', url: '#', icon: 'Square', tooltip: '커뮤니티'},
      {code: 'Travel', codeName: '여행가방', url: '#', icon: 'Travel', tooltip: '내 정보 보기'}
    ]
  }),
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  }
}
</script>
<style lang="scss" scoped>
.tooltip-coach {
  #tooltipHome {
    display: none;
    left: -50px;
    bottom: 330px;
    &:after {
      width: 100%;
      height: 220px;
      left: 25px;
      top: 40px;
      background-size: 12px auto;
      background-position: left bottom;
      background-image: var(--coach-mark-arrow-01);
    }
  }
  #tooltipLibrary {
    left: -42px;
    bottom: 245px;
    &:after {
      width: 100%;
      height: 135px;
      left: 25px;
      top: 40px;
      background-size: 12px auto;
      background-position: left bottom;
      background-image: var(--coach-mark-arrow-01);
    }
  }
  #tooltipChat {
    left: -32px;
    bottom: 165px;
    &:after {
      width: 100%;
      height: 55px;
      left: 20px;
      top: 40px;
      background-size: 12px auto;
      background-position: left bottom;
      background-image: var(--coach-mark-arrow-01);
    }
  }
  #tooltipMission {
    left: -65px;
    bottom: 165px;
    &:after {
      width: 100%;
      height: 55px;
      left: 40px;
      top: 40px;
      background-size: 12px auto;
      background-position: left bottom;
      background-image: var(--coach-mark-arrow-01);
    }
  }
  #tooltipSquare {
    left: -40px;
    bottom: 220px;
    &:after {
      width: 100%;
      height: 125px;
      left: 15px;
      top: 25px;
      background-size: 12px auto;
      background-position: left bottom;
      background-image: var(--coach-mark-arrow-01);
    }
  }
  #tooltipTravel {
    left: -35px;
    bottom: 155px;
    &:after {
      width: 100%;
      height: 65px;
      left: calc(50% - 6px);
      top: 20px;
      background-size: 12px auto;
      background-position: left bottom;
      background-image: var(--coach-mark-arrow-01);
    }
  }
}
</style>
